(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Finances",
                {
                    url: "/Finances",
                    component: "finances",
                    resolve: {
                        finance: ["transaction", "financeApi", function(transaction, financeApi) {
                            return financeApi.get(transaction.Id).catch(ng.noop);
                        }],
                        otherMonthlyIncomes: ["finance", "financeApi", function(finance, financeApi) {
                            return finance ? financeApi.getOtherFinanceByType(finance.Id, "MonthlyIncome") : [];
                        }],
                        otherMonthlyExpenses: ["finance", "financeApi", function (finance, financeApi) {
                            return finance ? financeApi.getOtherFinanceByType(finance.Id, "MonthlyExpense") : [];
                        }],
                        otherAssets: ["finance", "financeApi", function (finance, financeApi) {
                            return finance ? financeApi.getOtherFinanceByType(finance.Id, "Asset") : [];
                        }],
                        otherLiabilities: ["finance", "financeApi", function (finance, financeApi) {
                            return finance ? financeApi.getOtherFinanceByType(finance.Id, "Liability") : [];
                        }],
                        prevStage: ["transaction", "transactionApi", "_", function (transaction, transactionApi, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "Finances";
                                });

                            if (currIndex === 0) {
                                return transactionApi.getDisclosures(transaction.Id).then(function (disclosures) {
                                    return disclosures.length === 0 ? null : "Transaction.Disclose";
                                });
                            } else return "Transaction.Capture." + transaction.CapturePoints[currIndex - 1];
                        }],
                        nextStage: ["transaction", "_", function (transaction, _) {
                            var currIndex = _.findIndex(transaction.CapturePoints,
                                function (capturePoint) {
                                    return capturePoint === "Finances";
                                });

                            return currIndex === transaction.CapturePoints.length - 1
                                ? "Transaction.Determine.ProductChoice"
                                : "Transaction.Capture." + transaction.CapturePoints[currIndex + 1];
                        }]
                    },
                    redirectTo: "Transaction.Capture.Finances.Summary"
                });
        }
    ]);

    app.component("finances",
        {
            controller: financesController,
            templateUrl: "/App/Transaction/Capture/Finances/finances-template.html",
            bindings: {
                transaction: "<",
                finance: "<",
                otherMonthlyIncomes: "<",
                otherMonthlyExpenses: "<",
                otherAssets: "<",
                otherLiabilities: "<",
                prevStage: "<",
                nextStage: "<"
            }
        });

    financesController.$inject = ["$scope", "$state"];
    function financesController($scope, $state) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;
    }

})(window.app, window.angular); //jshint ignore:line